/*@flow*/
import React from 'react';
import ReactDOM from 'react-dom';

type PropsT = {
  position: { x: number, y: number },
  content: ?string,
};

export default (props: PropsT): any | null => {
  const node = document.querySelector('.leaflet-overlay-pane svg');
  if (!node) return null;
  if (!props.content) return null;
  return ReactDOM.createPortal(
    <text
      x={props.position.x}
      y={props.position.y}
      className="leaflet-zoom-animated"
      style={{
        pointerEvents: 'auto',
        visibility: 'visible',
      }}
    >
      {props.content}
    </text>,
    node
  );
};
